import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import type { GenericField } from '@Types';
import type { FieldInitialSettings, FieldSchema, RawField } from '@FormModule';
import { useSessionStore } from '@Stores';
import { useForm } from '@FormModule';

const fieldsSchema = ref<FieldSchema[]>([]);

export default function () {
  const { shelterProfile, userProfile } = storeToRefs(useSessionStore());
  const { getDetailsSchema } = useForm();

  const currentSchemaModels = ref<Set<GenericField>>(new Set());
  const fieldsSettings: FieldInitialSettings = {
    outcome_date: {
      model: new Date(),
      settings: {
        minDate: new Date(),
      },
    },
  };

  const rawFields = ref<RawField[]>([
    {
      label: 'Outcome Date',
      name: 'outcome_date',
      required: true,
      type: 'date',
      value: '',
    },
  ]);

  const userCanSetPaidDate = computed(
    () =>
      shelterProfile.value?.can_update_payment_at_cart &&
      shelterProfile.value?.can_update_payment_at_cart.includes(userProfile.value?._id)
  );

  function setForm(oldestIntakeDate: number) {
    // TODO :: AF-587 We need to have a outcome_date per animal and not per outcome
    fieldsSettings!.outcome_date!.settings!.minDate = new Date(oldestIntakeDate);

    if (userCanSetPaidDate.value) {
      fieldsSettings!.outcome_date!.settings!.minDate = null;
      setPaidDateField();
    }

    fieldsSchema.value = getDetailsSchema(rawFields.value, fieldsSettings);
  }

  function setPaidDateField() {
    rawFields.value.push({
      label: 'Paid Date',
      name: 'paid_date',
      required: false,
      type: 'date',
      value: null,
    });

    fieldsSettings.paid_date = {
      model: null,
      settings: {
        noModelOnStart: true,
      },
    };
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    rawFields,
    userCanSetPaidDate,
    setForm,
  };
}
